import React, { useState } from "react"
import { useAsyncFn } from "react-use"
import { IPanelBottomColour } from "../models/panel-bottom-color"
import { IPanelThickness } from "../models/panel-thickness"
import { getPanelBottomColours, getPanelCores, getPanelProfiles, getPanelThicknesses } from "../api/panels-api"
import { IPanelProfiles } from "../models/panel-profile"
import { IPanelCores } from "../models/panel-core"
import { getColours, getProductIdByName } from "../api"
import { IColour } from "../models/colour"
import { getFixingUnitTypes } from "../api/fixings-api"
import { IFixingUnitTypeProducts } from "../models/fixings/fixingUnitTypeProducts"
import { getAllProduct as getAllLightProducts, getLightProductMaster, getLightProductOptions, getLightUnitPrice } from "../api/light-api"
import {
    getProductFlashingColours,
    getProductFlashingSubTypes,
    getProductFlashingThicknesses,
    getProductFlashingTypes,
    getFlashingUnitPrice,
    getFlashingProductOptions
} from '../api/flashings-api'
import { 
    getProductFixings,
    getProductFixingScrewTypes,
    getFixingUnitPrice,
    getFixingProductOptions
} from "../api/fixings-api"
import { 
    getBeamsPM,
    getBeamTypesProdMasterlist,
    getBeamColours,
    getBeamProductDetails,
    getBeamProductOptions
} from "../api/beams-api"
import { 
    getPostTypesPM,
    getBeamSizesPM,
    getAllPostColoursPM,
    getPostProductDetails,
    getPostProductOptions,
    getPostUnitPrice
} from "../api/posts-api"
import { 
    getPanelProductOptions,
    getPanelProductDetails
} from "../api/panels-api"
import { IFlashingType } from "../models/flashings/flashingType"
import { IFlashingSubtype } from "../models/flashings/flashingSubtype"
import { IFlashingThickness } from "../models/flashings/flashingThickness"
import { IFixing } from "../models/fixings/fixing"
import { IBeamsProducts } from "../models/beams/beamProducts"
import { IBeamSize } from "../models/beams/beamSizes"
import { IPostType } from "../models/posts/postType"
import { getAllProduct as getAllRainwaterProduct, getRainwaterProductOptions, getRainwaterUnitPrice } from "../api/rainwater-api"
import { getAllProduct as getAllAccessoryProduct, getAccessoryProductOptions, getAccessoryUnitPrice } from "../api/accessory-api"
import { IPanelCutback } from "../models/panel-cutback"
import { IPanelDirectionLay } from "../models/panel-direction-lay"
import { IRainWaterPart } from "../models/rainwater/rainWaterParts"
import { IRainWaterStyle } from "../models/rainwater/rainWaterStyles"
import { IAccessoryStyle } from "../models/accessories/accessoryStyles"
import { ILightProduct } from "../models/lights/lightProduct"
import { ILightProductType } from "../models/lights/lightProductType"
import { ILightProfile } from "../models/lights/lightProfiles"
import { ILightThickness } from "../models/lights/lightThickness"
import { PRODUCT_IMPORT_TYPE_POST, ORDER_TAB_POSTS, ORDER_TAB_POSTS_KIT, BeamProducts } from "../common/constant"

export const AdminOrderSummaryContext = React.createContext<any>({})

export const AdminOrderSummaryContextProvider: React.FC = ({children}) => {

    const fetchPanelOptions = async () => {
        if (!fetchPanelBottomColours && !panelBottomColour) {
            await fetchPanelBottomColoursAsync()
        }
        if (!fetchPanelThicknesses && !panelThickness) {
            await fetchPanelThicknessesAsync()
        }
        if (!fetchPanelProfiles && !panelProfiles) {
            await fetchPanelProfilesAsync()
        }
        if (!fetchPanelCores && !panelCores) {
            await fetchPanelCoresAsync()
        }
        if (!fetchColours && !colours) {
            await fetchColoursAsync()
        }
    }
    
    //** Panel Thickness **//
    const [panelThickness, setPanelThickness] = useState<IPanelThickness[] | undefined>()
    const [{loading: fetchPanelThicknesses}, fetchPanelThicknessesAsync] = useAsyncFn(async () => {
    try {
        const result: any = await getPanelThicknesses()
        if (result != null) {
        setPanelThickness(result.data)
        }
    } catch (error) {
        console.error('Error in fetchPanelThicknessesAsync:', error)
    }
    }, [setPanelThickness])
    
    //** Panel Profiles **//
    const [panelProfiles, setPanelProfiles] = useState<IPanelProfiles[] | undefined>()
    const [{loading: fetchPanelProfiles}, fetchPanelProfilesAsync] = useAsyncFn(async () => {
    const result: any = await getPanelProfiles()
    if (result != null) {
        setPanelProfiles(result.data)
    }
    }, [setPanelProfiles])
    //** Panel Cores **//
    const [panelCores, setPanelCores] = useState<IPanelCores[] | undefined>()
    const [{loading: fetchPanelCores}, fetchPanelCoresAsync] = useAsyncFn(async () => {
    const result: any = await getPanelCores()
    if (result != null) {
        setPanelCores(result.data)
    }
    }, [setPanelCores])
    //** Bottom Colour **//
    const [panelBottomColour, setPanelBottomColours] = useState<IPanelBottomColour[] | undefined>()
    const [{loading: fetchPanelBottomColours}, fetchPanelBottomColoursAsync] =
    useAsyncFn(async () => {
        const result: any = await getPanelBottomColours()
        if (result != null) {
        setPanelBottomColours(result.data)
        }
    }, [setPanelBottomColours])
    //** Panel Colour **//
    const [colours, setColours] = useState<IColour[] | undefined>()
    const [{loading: fetchColours}, fetchColoursAsync] = useAsyncFn(async () => {
    const result: any = await getColours()
        if (result != null) {
            setColours(result.data)
        }
    }, [setColours])


    const fetchFixingOptions = async () => {
        // if (!fixings) {
        //     getFixingAsync()
        // }
        if (!fetchUnitTypes && !fixingUnitTypesProducts) {
            fetchUnitTypesAsync()
        }
    }
    const [fixingUnitTypesProducts, setFixingUnitTypesProducts] = useState<IFixingUnitTypeProducts[] | undefined>()
    const [{loading: fetchUnitTypes}, fetchUnitTypesAsync] = useAsyncFn(async () => {
        const result: any = await getFixingUnitTypes()
        if (result != null) {
            const mappedData: any[] = result.data.map((item: {
                id: number
                unitTypeId: number
                unitTypeName: string
                }) => ({
                id: item.unitTypeId,
                name: item.unitTypeName
            }))
            setFixingUnitTypesProducts(mappedData)
        }
    }, [setFixingUnitTypesProducts])


    //** Lights **//
    const [lightProductMaster, setLightProductMaster] = useState<[] | undefined>()
    const [{loading: fetchLightProductMaster}, fetchLightProductMasterAsync] = useAsyncFn(async (pricebookId) => {
    const result: any = await getLightProductMaster(pricebookId)
        if (result != null) {
            setLightProductMaster(result.data)
        }
    }, [setLightProductMaster])


    //Flashings
    const [flashingTypes, setFlashingTypes] = useState<IFlashingType[] | undefined>()
    const [flashingSubTypes, setFlashingSubTypes] = useState<IFlashingSubtype[] | undefined>()
    const [flashingThicknesses, setFlashingThicknesses] = useState<IFlashingThickness[] | undefined>()
    const [flashingColours, setFlashingColours] = useState<IColour[] | undefined>()
    const [flashingUnitPrice, setFlashingUnitPrice] = useState<number>(0)
    const [flashingProductDetails, setFlashingProductDetails] = useState<any>(null)

    const fetchFlashingProductOptions = async (priceBookId: number, flashingTypeId?: number, key?: string) => {
        try {
            const flashingRes: any = await getFlashingProductOptions(priceBookId, flashingTypeId, undefined, undefined, undefined, key)

            setFlashingTypes(flashingRes.flashingTypes)
            setFlashingSubTypes(flashingRes.flashingSubTypes)
            setFlashingThicknesses(flashingRes.flashingThicknesses)
            setFlashingColours(flashingRes.flashingColours)
        } catch (error) {
            console.error("Error fetching flashing product options:", error)
        }
    }

    const [{loading: fetchingFlashingUnitPrice}, getFlashingUnitPriceAsync] = useAsyncFn(
        async (flashingTypeId: number, flashingSubTypeId: number, flashingThicknessId: number, colourId: number, priceLevel?: number) => {
        const prodDetails: any = await getFlashingUnitPrice(flashingTypeId, flashingSubTypeId, flashingThicknessId, colourId, priceLevel)
        if (prodDetails != null) {
            setFlashingUnitPrice(prodDetails.priceLevel1 ? prodDetails.priceLevel1 : 0)
            setFlashingProductDetails(prodDetails)
        }
      }, [setFlashingUnitPrice])


    //Fixings
    const [productFixings, setProductFixings] = useState<IFixing[] | undefined>()
    const [fixingScrewTypes, setFixingScrewTypes] = useState<{ id: number; name: string }[] | undefined>()
    const [fixingColours, setFixingColours] = useState<IColour[] | undefined>()
    const [fixingUnitPrice, setFixingUnitPrice] = useState<number>(0)
    const [fixingProductDetails, setFixingProductDetails] = useState<any>(null)

    const fetchFixingProductOptions = async (pricebookId?: number, fixingId?: number, key?: string) => {
        try {
            const fixingRes: any = await getFixingProductOptions(pricebookId, undefined, undefined, fixingId, key)

            setProductFixings(fixingRes.fixings)
            setFixingScrewTypes(fixingRes.screwTypes)
            setFixingColours(fixingRes.colours)
        } catch (error) {
            console.error("Error fetching fixing product options:", error)
        }
    }

    const [{loading: fetchingFixingUnitPrice}, getFixingUnitPriceAsync] = useAsyncFn(
        async (fixingId: number, screwType?: string, colourId?: number, priceLevel?: number) => {
        
        const prodDetails: any = await getFixingUnitPrice(fixingId, screwType, colourId, priceLevel)
        if (prodDetails != null) {
            setFixingUnitPrice(prodDetails.priceLevel1 ? prodDetails.priceLevel1 : 0)
            setFixingProductDetails(prodDetails)
        }
      }, [setFixingUnitPrice])

    //Beams
    const [beamProducts, setBeamProducts] = useState<IBeamsProducts[] | undefined>()
    const [beamSizes, setBeamSizes] = useState<IBeamSize[] | undefined>()
    const [beamColours, setBeamColours] = useState<IColour[] | undefined>()
    const [beamUnitPrice, setBeamUnitPrice] = useState<number>(0)
    const [beamProductDetails, setBeamProductDetails] = useState<any>(null)
    const [beamHasLength, setBeamHasLength] = useState<boolean>(true)

    const fetchBeamProductOptions = async (priceBookId: number, beamProductId?: number, key?: string) => {
        try {
            const beamRes: any = await getBeamProductOptions(priceBookId, beamProductId, undefined, undefined, key)

            setBeamProducts(beamRes.beamProducts)
            setBeamSizes(beamRes.beamSizes)
            setBeamColours(beamRes.colours)

            if (beamProductId && beamRes.beamProducts?.length) {
            const selectedBeam = beamRes.beamProducts.find((bp: any) => bp.id === beamProductId)

            if (
                selectedBeam &&
                selectedBeam.name !== BeamProducts.SteelBeam &&
                selectedBeam.name !== BeamProducts.AluminiumBeam
            ) {
                setBeamHasLength(false)
            } else {
                setBeamHasLength(true)
            }
            }
        } catch (error) {
            console.error("Error fetching beam product options:", error)
        }
    }

    const [{loading: fetchingBeamUnitPrice}, getBeamUnitPriceAsync] = useAsyncFn(
        async (beamProductId: number, beamSizeId: number, beamColourId: number, priceLevel?: number) => {

        const prodDetails: any = await getBeamProductDetails(beamProductId, beamSizeId, beamColourId, priceLevel)
        if (prodDetails != null) {
            setBeamUnitPrice(prodDetails.priceLevel1 ? prodDetails.priceLevel1 : 0)
            setBeamProductDetails(prodDetails)
        }
      }, [setBeamUnitPrice])

    //Posts
    const [postTypes, setPostTypes] = useState<IPostType[] | undefined>()
    const [postBeamSizes, setPostBeamSizes] = useState<IBeamSize[] | undefined>()
    const [postExtenderLengths, setPostExtenderLengths] = useState<IBeamSize[] | undefined>()
    const [postColours, setPostColours] = useState<IColour[] | undefined>()
    const [postUnitPrice, setPostUnitPrice] = useState<number>(0)
    const [postProductDetails, setPostProductDetails] = useState<any>(null)
    const [postProductId, setPostProductId] = useState<number>(0)
    const [postKitProductId, setPostKitProductId] = useState<number>(0)
    const [postExtendaBracketId, setPostExtendaBracketId] = useState<number>(0)

    const [{loading: fetchingPostProductIdByName}, getPostProductIdByNameAsync] = useAsyncFn(async (
        postProductName: string) => {
        const productId: any = await getProductIdByName(postProductName, PRODUCT_IMPORT_TYPE_POST)
        if (productId != null) {
            if (postProductName === ORDER_TAB_POSTS) {
                setPostProductId(productId.productId)
            }
            else if (postProductName === ORDER_TAB_POSTS_KIT) {
                setPostKitProductId(productId.productId)
            }
            else {
                setPostExtendaBracketId(productId.productId)
            }
        }
      }, [setPostProductId, setPostKitProductId, setPostExtendaBracketId])

    const fetchPostProductOptions = async (pricebookId?: number, postProductId?: number, key?: string) => {
        try {
            const postOptions: any = await getPostProductOptions(pricebookId, postProductId, undefined, undefined, undefined, undefined, key)

            setPostTypes(postOptions.postTypes || [])
            setPostBeamSizes(postOptions.beamSizes || [])
            setPostColours(postOptions.colours || [])
            setPostExtenderLengths(postOptions.extenderLengths || [])
        } catch (error) {
            console.error("Error fetching post product options:", error)
        }
    }

    const [{loading: fetchingPostBeamSizes}, getPostBeamSizesAsync] = useAsyncFn(async (postProductId: number, postTypeId?: number) => {
        const beamSizes: any = await getBeamSizesPM(postProductId, postTypeId);
        if (beamSizes != null) {
        setPostBeamSizes(beamSizes.data)
        }
    }, [setPostBeamSizes])

    // const [{loading: fetchingPostUnitPrice}, getPostUnitPriceAsync] = useAsyncFn(
    //     async (postTypeId: number, postBeamSizeId: number, postColourId: number) => {
        
    //     const prodDetails: any = await getPostProductDetails(postTypeId, postBeamSizeId, postColourId)
    //     if (prodDetails != null) {
    //         setPostUnitPrice(prodDetails.priceLevel1 ? prodDetails.priceLevel1 : 0)
    //         setPostProductDetails(prodDetails)
    //     }
    //   }, [setPostUnitPrice])

    const [{loading: fetchingPostUnitPrice}, getPostUnitPriceAsync] = useAsyncFn(
        async (postProductId: number, postTypeId: number, colourId?: number, beamSizeId?: number, extenderLengthId?: number, length?: number, priceLevel?: number) => {
        const postUnitPrice: any = await getPostUnitPrice(postProductId, postTypeId, colourId, beamSizeId, extenderLengthId, length, priceLevel)
        if (postUnitPrice != null) {
            setPostUnitPrice(postUnitPrice.priceLevel1 ? postUnitPrice.priceLevel1 : 0)
            setPostProductDetails(postUnitPrice.postProductMasters)
        }
    }, [setPostUnitPrice])

    //Panels
    const [productPanelBottomColours, setProductPanelBottomColours] = useState<IPanelBottomColour[] | undefined>()
    const [productPanelCores, setProductPanelCores] = useState<IPanelCores[] | undefined>()
    const [productPanelProfiles, setProductPanelProfiles] = useState<IPanelProfiles | undefined>()
    const [productPanelRoofColours, setProductPanelRoofColours] = useState<IColour[] | undefined>()
    const [productPanelThicknesses, setProductPanelThicknesses] = useState<IPanelThickness[] | undefined>()
    const [productPanelCutbacks, setProductPanelCutbacks] = useState<IPanelCutback[] | undefined>()
    const [productPanelDirectionalLays, setProductPanelDirectionalLays] = useState<IPanelDirectionLay[] | undefined>()
    const [panelUnitPrice, setPanelUnitPrice] = useState<number>(0)
    const [panelProductDetails, setPanelProductDetails] = useState<any>(null)

    const fetchPanelProductOptions = async (pricebookId?: number) => {
        try {
            const panelOptions: any = await getPanelProductOptions(pricebookId ? pricebookId : 0)

            setProductPanelBottomColours(panelOptions.panelBottomColours)
            setProductPanelCores(panelOptions.panelCores)
            setProductPanelProfiles(panelOptions.panelProfiles)
            setProductPanelRoofColours(panelOptions.panelRoofColours)
            setProductPanelThicknesses(panelOptions.panelThicknesses)
            setProductPanelCutbacks(panelOptions.panelCutbacks)
            setProductPanelDirectionalLays(panelOptions.panelDirectionalLays)
        } catch (error) {
            console.error("Error fetching panel product options:", error)
        }
    }

    const [{loading: fetchingPanelUnitPrice}, getPanelUnitPriceAsync] = useAsyncFn(
        async (panelProfileId: number, 
            panelCoreId: number, 
            panelThicknessId: number,
            panelRoofColourId: number, 
            panelBottomColourId: number, 
            pricebookId: number,
            priceLevel?: number) => {
        
        const prodDetails: any = await getPanelProductDetails(panelProfileId, panelCoreId, panelThicknessId, 
            panelRoofColourId, panelBottomColourId, pricebookId, priceLevel)

        if (prodDetails != null) {
            setPanelUnitPrice(prodDetails.priceLevel1 ? prodDetails.priceLevel1 : 0)
            setPanelProductDetails(prodDetails)
        }
      }, [setPanelUnitPrice])

    // Rainwater
    const [rainwaterProductMaster, setRainwaterProductMaster] = useState<[] | undefined>()
    const [productRainwaterParts, setProductRainwaterParts] = useState<IRainWaterPart[] | undefined>()
    const [productRainwaterStyles, setProductRainwaterStyles] = useState<IRainWaterStyle | undefined>()
    const [productRainwaterColours, setProductRainwaterColours] = useState<IColour[] | undefined>()
    const [rainwaterUnitPrice, setRainwaterUnitPrice] = useState<number>(0)
    const [rainwaterProductDetails, setRainwaterProductDetails] = useState<any>(null)

    const [{loading: fetchRainwaterProductMaster}, fetchRainwaterProductMasterAsync] = useAsyncFn(async (pricebookId: number) => {
    const result: any = await getAllRainwaterProduct(pricebookId)
        if (result != null) {
            setRainwaterProductMaster(result)
        }
    }, [setRainwaterProductMaster])

    const fetchRainwaterProductOptions = async (pricebookId?: number, rainwaterPartId?: number, rainwaterStyleId?: number, key?: string) => {
        try {
            const rainwaterOptions: any = await getRainwaterProductOptions(pricebookId, rainwaterPartId, rainwaterStyleId, undefined, key)

            setProductRainwaterParts(rainwaterOptions.rainwaterParts || [])
            setProductRainwaterStyles(rainwaterOptions.rainwaterStyles || [])
            setProductRainwaterColours(rainwaterOptions.colours || [])
        } catch (error) {
            console.error("Error fetching rainwater product options:", error)
        }
    }

    const [{loading: fetchingRainwaterUnitPrice}, getRainwaterUnitPriceAsync] = useAsyncFn(
        async (rainwaterPartId: number, rainwaterStyleId: number, rainwaterColourId?: number, priceLevel?: number) => {
        const rainwaterProdDetails: any = await getRainwaterUnitPrice(rainwaterPartId, rainwaterStyleId, rainwaterColourId, priceLevel)
        if (rainwaterProdDetails != null) {
            setRainwaterUnitPrice(rainwaterProdDetails.priceLevel1 ? rainwaterProdDetails.priceLevel1 : 0)
            setRainwaterProductDetails(rainwaterProdDetails)
        }
    }, [setRainwaterUnitPrice])

    // Accessories
    const [accessoryProductMaster, setAccessoryProductMaster] = useState<[] | undefined>()
    const [productAccessoryStyles, setProductAccessoryStyles] = useState<IAccessoryStyle | undefined>()
    const [productAccessoryColours, setProductAccessoryColours] = useState<IColour[] | undefined>()
    const [accessoryUnitPrice, setAccessoryUnitPrice] = useState<number>(0)
    const [accessoryProductDetails, setAccessoryProductDetails] = useState<any>(null)
    const [{loading: fetchAccessoryProductMaster}, fetchAccessoryProductMasterAsync] = useAsyncFn(async (pricebookId: number) => {
    const result: any = await getAllAccessoryProduct(pricebookId)
        if (result != null) {
            setAccessoryProductMaster(result)
        }
    }, [setAccessoryProductMaster])
    
    const fetchAccessoryProductOptions = async (pricebookId?: number, accessoryStyleId?: number, key?: string) => {
        try {
            const accessoryOptions: any = await getAccessoryProductOptions(pricebookId, accessoryStyleId, undefined, key)

            setProductAccessoryStyles(accessoryOptions.accessoryStyles || [])
            setProductAccessoryColours(accessoryOptions.colours || [])
        } catch (error) {
            console.error("Error fetching accessory product options:", error)
        }
    }

    const [{loading: fetchingAccessoryUnitPrice}, getAccessoryUnitPriceAsync] = useAsyncFn(
        async (accessoryStyleId: number, accessoryColourId?: number, priceLevel?: number) => {
        const accessoryProdDetails: any = await getAccessoryUnitPrice(accessoryStyleId, accessoryColourId, priceLevel)
        if (accessoryProdDetails != null) {
            setAccessoryUnitPrice(accessoryProdDetails.priceLevel1 ? accessoryProdDetails.priceLevel1 : 0)
            setAccessoryProductDetails(accessoryProdDetails)
        }
    }, [setAccessoryUnitPrice])

    // Lights
    const [productLightProducts, setProductLightProducts] = useState<ILightProduct[] | undefined>()
    const [productLightProfiles, setProductLightProfiles] = useState<ILightProfile[] | undefined>()
    const [productLightDetails, setProductLightDetails] = useState<{ id: number; name: string }[] | undefined>()
    const [productLightThicknesses, setProductLightThicknesses] = useState<IColour[] | undefined>()
    const [lightUnitPrice, setLightUnitPrice] = useState<number>(0)
    const [lightProductDetails, setLightProductDetails] = useState<any>(null)
    const fetchLightProductOptions = async (pricebookId?: number, lightProductId?: number, lightsDetail?: string, key?: string) => {
        try {
            const lightOptions: any = await getLightProductOptions(pricebookId, lightProductId, lightsDetail, undefined, undefined, key)

            setProductLightProducts(lightOptions.lightProducts || [])
            setProductLightProfiles(lightOptions.lightProfiles || [])
            setProductLightDetails(lightOptions.lightDetails || [])
            setProductLightThicknesses(lightOptions.lightThicknesses || [])
        } catch (error) {
            console.error("Error fetching light product options:", error)
        }
    }

    const [{loading: fetchingLightUnitPrice}, getLightUnitPriceAsync] = useAsyncFn(
        async (lightProductId: number, lightsDetail: string, lightPanelTypeId?: number, lightThicknessId?: number, length?: number, priceLevel?: number) => {
        const lightProdDetails: any = await getLightUnitPrice(lightProductId, lightsDetail, lightPanelTypeId, lightThicknessId, length, priceLevel)
        if (lightProdDetails != null) {
            setLightUnitPrice(lightProdDetails.priceLevel1 ? lightProdDetails.priceLevel1 : 0)
            setLightProductDetails(lightProdDetails)
        }
    }, [setLightUnitPrice])

    return(
        <AdminOrderSummaryContext.Provider value={{
            fetchPanelOptions,
            panelThickness,
            panelProfiles,
            panelCores,
            panelBottomColour,
            colours,
            fetchLightProductMasterAsync,
            lightProductMaster,
            flashingTypes,
            flashingSubTypes,
            flashingThicknesses,
            flashingColours,
            fetchFlashingProductOptions,
            getFlashingUnitPriceAsync,
            flashingProductDetails,
            flashingUnitPrice,
            productFixings,
            fixingScrewTypes,
            fixingColours,
            fixingUnitPrice,
            fixingProductDetails,
            fetchFixingProductOptions,
            getFixingUnitPriceAsync,
            beamProducts,
            beamSizes,
            beamColours,
            beamHasLength,
            beamUnitPrice,
            beamProductDetails,
            fetchBeamProductOptions,
            getBeamUnitPriceAsync,
            postTypes,
            postBeamSizes,
            postExtenderLengths,
            postColours,
            postUnitPrice,
            postProductDetails,
            getPostProductIdByNameAsync,
            postProductId,
            postKitProductId,
            postExtendaBracketId,
            getPostBeamSizesAsync,
            fetchPostProductOptions,
            getPostUnitPriceAsync,
            productPanelBottomColours,
            productPanelCores,
            productPanelProfiles,
            productPanelRoofColours,
            productPanelThicknesses,
            productPanelCutbacks,
            productPanelDirectionalLays,
            panelUnitPrice,
            panelProductDetails,
            fetchPanelProductOptions,
            getPanelUnitPriceAsync,            
            fetchRainwaterProductMasterAsync,
            rainwaterProductMaster,
            fetchRainwaterProductOptions,
            productRainwaterParts,
            productRainwaterStyles,
            productRainwaterColours,
            setProductRainwaterParts,
            setProductRainwaterStyles,
            setProductRainwaterColours,
            getRainwaterUnitPriceAsync,
            rainwaterUnitPrice,
            rainwaterProductDetails,
            fetchAccessoryProductMasterAsync,
            accessoryProductMaster,
            productAccessoryStyles,
            productAccessoryColours,
            fetchAccessoryProductOptions,
            accessoryUnitPrice,
            accessoryProductDetails,
            getAccessoryUnitPriceAsync,
            productLightProducts,
            productLightProfiles,
            productLightDetails,
            productLightThicknesses,
            fetchLightProductOptions,
            lightUnitPrice,
            lightProductDetails,
            getLightUnitPriceAsync
        }}>
             {children}
        </AdminOrderSummaryContext.Provider>
    )
}